module.exports = __webpack_public_path__ + "img/login-logo.87287e5f.webp";